module.exports = __webpack_public_path__ + "img/button_next_top_active.bb1d4d7e.svg";